<div class="new-commission-container">
  <div class="title">
    <button class="cancel" (click)="goBack()">
      <img src="assets/icones/close_icon.svg" alt="">
    </button>
    <span>{{ 'commission.new.title' | translate }}</span>
  </div>
  <div class="steps">
    <div
      [id]="'step-'+$idx"
      class="step"
      *ngFor="let step of creationSteps; let $idx = index; let isLast = last"
      [class.active]="step.active"
      [class.completed]="step.completed && !step.active"
      (click)="goToStep($idx)"
    >
      <span class="step-icon"></span>
      <span class="step-label">{{ step.label | translate }}</span>
      <div class="separtor" *ngIf="!isLast">
        <img src="assets/icones/chevron_right.svg" alt="">
      </div>
    </div>
  </div>
  <div class="step-content">
    <ng-container [ngTemplateOutlet]="currentStepIndex === 0 ? details : currentStepIndex === 1 ? thresholds : currentStepIndex === 2 ? negotiation : summary"></ng-container>
  </div>
</div>

<ng-template #details>
  <app-new-commission-details (nextStep)="next($event)" [commission]="commissionPayload"></app-new-commission-details>
</ng-template>

<ng-template #thresholds>
  <app-new-commission-thresholds (nextStep)="next($event)" (previousStep)="previous($event)" [commission]="commissionPayload"></app-new-commission-thresholds>
</ng-template>

<ng-template #negotiation>
  <app-new-commission-negotiation (nextStep)="next($event)" (previousStep)="previous($event)" [commission]="commissionPayload"></app-new-commission-negotiation>
</ng-template>

<ng-template #summary>
  <app-new-commission-summary (nextStep)="next($event)" (previousStep)="previous($event)" [commission]="commissionPayload"></app-new-commission-summary>
</ng-template>
